module.exports = __webpack_public_path__ + "img/item-2.3199ea9.svg";